/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S6_Li1Inputs */

const tr_servis_s6_li1 = /** @type {(inputs: Servis_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (tam veritabanı dökümü)`)
};

const en_servis_s6_li1 = /** @type {(inputs: Servis_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (full database dump)`)
};

const de_servis_s6_li1 = /** @type {(inputs: Servis_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (vollständiger Datenbankabzug)`)
};

const ru_servis_s6_li1 = /** @type {(inputs: Servis_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (полная выгрузка базы данных)`)
};

/**
* | output |
* | --- |
* | "JSON (full database dump)" |
*
* @param {Servis_S6_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s6_li1 = /** @type {((inputs?: Servis_S6_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S6_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s6_li1(inputs)
	if (locale === "de") return de_servis_s6_li1(inputs)
	if (locale === "ru") return ru_servis_s6_li1(inputs)
	return tr_servis_s6_li1(inputs)
});